import React from 'react';
import { connect } from 'react-redux';
import FilterToggles from '@/components/buttons/FilterToggles';
import { updateTokensFlags } from '../actions';
import { tokenStatus } from '../constants';

const TokensFilters = ({
  category,
  activeFlag,
  expiredFlag,
  updateFlags,
}) => (
  <FilterToggles filters={[
    {
      active: activeFlag,
      icon: 'code',
      key: 'active_tokens_filter',
      messageId: `tokens.status.filter.${tokenStatus.ACTIVE}`,
      onClick: () => updateFlags(category, !activeFlag, expiredFlag, false),
    },
    {
      active: expiredFlag,
      icon: 'wait',
      key: 'expired_tokens_filter',
      messageId: `tokens.status.filter.${tokenStatus.EXPIRED}`,
      onClick: () => updateFlags(category, activeFlag, !expiredFlag, false),
    },
  ]}
  />
);

const mapStateToProps = ({
  tokens: { tokens },
}, { category }) => {
  const { activeFlag, expiredFlag } = tokens[category];
  return ({ activeFlag, expiredFlag });
};

const mapDispatchToProps = {
  updateFlags: updateTokensFlags,
};

export default connect(mapStateToProps, mapDispatchToProps)(TokensFilters);
